export default __webpack_public_path__ + "static/media/element_92.3f8e7d48.jpg";